import './App.css';
import './index.css';
import React from 'react';
import { Provider } from "react-redux";
import store from "./data";
import { Route, Routes, createBrowserRouter, RouterProvider } from 'react-router-dom';
import Login from './components/login.tsx';
import Admin from './components/admin/index.tsx';
import Logistics from './components/logistics/index.tsx';
import ContactManage from './components/settings/contact/index.tsx';
import ContainerPlanner from './components/planner/index.tsx';
import ContainerTypeManage from './components/settings/containerType/index.tsx';
import LabelManage from './components/settings/label/index.tsx';
import TerminalManage from './components/settings/terminal/index.tsx';
import GenesisAdmin from './components/genesis/index.tsx';
import VesselManage from './components/settings/vessel/index.tsx';
import TerminalView from './components/terminalview/index.tsx';
import Reports from './components/reports/index.tsx';
import ContainerUpload from './components/logistics/container-upload/index.tsx';
import VoyageList from './components/voyage/index.tsx';
import MobileVesselPlanning from './components/mobile/planning/index.tsx';
import VolumeReport from './components/reports/volume/index.tsx';
import WeeklyOperationsReport from './components/reports/weeklyReport/index.tsx';
import VoyageTerminalCallContainerManager from './components/voyage/manage/index.tsx';
import GasoilAndBunkeringPage from './components/vessel/gasoil/index.tsx';
import MobileGasoilPage from './components/mobile/gasoil/MobileGasoilPage.tsx';

function App() {
  const router = createBrowserRouter(
    [
      {
        path: "*",
        element: (
          <Provider store={store} >
            <Routes>
              <Route path='/' Component={Login}></Route>
              <Route path='/admin/*' Component={Admin}></Route>
              <Route path='/genesis' Component={GenesisAdmin}></Route>
              <Route path='/logistics' Component={Logistics}></Route>
              <Route path='/logistics/container-upload' Component={ContainerUpload}></Route>
              <Route path='/container-planner' Component={ContainerPlanner}></Route>
              <Route path='/terminal-view' Component={TerminalView}></Route>
              <Route path='/reports' Component={Reports}></Route>
              <Route path='/reports/volume' Component={VolumeReport}></Route>
              <Route path='/settings/terminal' Component={TerminalManage}></Route>
              <Route path='/settings/container-type' Component={ContainerTypeManage}></Route>
              <Route path='/settings/vessel' Component={VesselManage}></Route>
              <Route path='/settings/contact' Component={ContactManage}></Route>
              <Route path='/settings/label' Component={LabelManage}></Route>
              <Route path='/voyages' Component={VoyageList}></Route>
              <Route path='/mobile/planning' Component={MobileVesselPlanning}></Route>
              <Route path='/mobile/gasoil' Component={MobileGasoilPage}></Route>
              <Route path='/reports/weekly-report' Component={WeeklyOperationsReport}></Route>
              <Route path='/voyages/manage' Component={VoyageTerminalCallContainerManager}></Route>
              <Route path='/vessel/gasoil' Component={GasoilAndBunkeringPage}></Route>
            </Routes>
          </Provider>
        ),
      },
    ],
  );
  return <RouterProvider router={router} />;
}

export default App;
